
import { clientActionTypes } from './client.types';

const INITIAL_STATE = {
    currentClient: null
};

const clientReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case clientActionTypes.SET_CURRENT_USER:
            return {
                ...state,
                currentClient: action.payload
            };
        default:
            return state;
    }
};

export default clientReducer;